import getDefaultSpecialOffersPaymentOptions from '../utils/getDefaultSpecialOffersPaymentOptions';
import isNonNullable from '../../../utils/isNonNullable';
import useFetchMultiplePayments from '../../../core/apiHooks/useFetchMultiplePayments';
import useSpecialOffersConfiguration from './useSpecialOffersConfiguration';
import { selectCanUseLoyalty } from '../../../core/reducers/offerOptions';
import { selectPrimaryCalculatorPaymentOptions } from '../../../core/reducers/financialCalculators';
import { useAppSelector } from '../../../core/utils';
const useFetchAllPaymentsWithOffer = (trims, shouldFetch) => {
    const customPaymentOptions = [];
    const primaryCalculatorPaymentOptions = useAppSelector(selectPrimaryCalculatorPaymentOptions);
    const canUseLoyalty = useAppSelector(selectCanUseLoyalty);
    const config = useSpecialOffersConfiguration();
    const paymentRequestPayloads = trims.map(trim => {
        const { modelKey, modelYear, trimKey, transmissionKey, exteriorColorKey, interiorColorKey } = trim;
        const { defaultPaymentMethod, defaultFrequency, defaultTerm, defaultDownPayment, defaultIncentiveOffers, loyaltyOfferKey, } = getDefaultSpecialOffersPaymentOptions(trim, config);
        customPaymentOptions.push({
            ...primaryCalculatorPaymentOptions,
            ...(!!defaultPaymentMethod && { paymentMethod: defaultPaymentMethod }),
            ...(!!defaultFrequency && { paymentFrequency: defaultFrequency }),
            ...(!!defaultTerm && { termAndRate: Number(defaultTerm) }),
            ...(!!defaultDownPayment && { downPaymentAmount: Number(defaultDownPayment) }),
            ...(defaultIncentiveOffers && !!defaultIncentiveOffers.length && { incentiveOfferIds: defaultIncentiveOffers }),
            ...(canUseLoyalty && { loyaltyOfferKey }),
        });
        return {
            modelKey,
            modelYear,
            trimKey,
            transmissionKey,
            exteriorColorKey,
            interiorColorKey,
            protections: [],
            protectionAddOns: [],
        };
    });
    const paymentResponse = useFetchMultiplePayments(paymentRequestPayloads, shouldFetch, customPaymentOptions);
    const { data: paymentData, isFetching: isPaymentDataFetching, isLoading: isPaymentDataLoading, isSuccess: isPaymentDataSuccess, } = paymentResponse;
    const isPaymentDataLoadedSuccess = !isPaymentDataLoading && !isPaymentDataFetching && isPaymentDataSuccess && !!(paymentData === null || paymentData === void 0 ? void 0 : paymentData.length);
    if (!isPaymentDataLoadedSuccess) {
        return {
            ...paymentResponse,
            data: [],
        };
    }
    const paymentMap = (paymentData !== null && paymentData !== void 0 ? paymentData : []).reduce((map, payment) => {
        if (!(payment === null || payment === void 0 ? void 0 : payment.detKeys.transmissionKey))
            return map;
        map.set(payment.detKeys.transmissionKey, payment);
        return map;
    }, new Map());
    const trimDataWithPayment = trims
        .map(trim => {
        const payment = paymentMap.get(trim.transmissionKey);
        if (!payment)
            return null;
        return {
            ...trim,
            payment,
        };
    })
        .filter(isNonNullable);
    return {
        ...paymentResponse,
        data: trimDataWithPayment,
    };
};
export default useFetchAllPaymentsWithOffer;
